import { render, staticRenderFns } from "./StorageTable.vue?vue&type=template&id=ce8805ec"
import script from "./StorageTable.vue?vue&type=script&lang=js"
export * from "./StorageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports